import { Routes, Route, Navigate } from 'react-router-dom';
import { LoginForm } from '../components/Auth/LoginForm';
import { DashboardLayout } from '../components/Layout/Dashboard';
import { DashboardPage } from '../pages/Dashboard/Dashboard';
import { CompetitionsPage } from '../pages/Competitions/Competitions';
import { ExercisesPage } from '../pages/Exercises/Exercises';
import { ProgramsPage } from '../pages/Programs/Programs';
import { ConstrainedProgramsPage } from '../pages/ConstrainedPrograms/ConstrainedPrograms';
import { ProtectedRoute } from '../components/Auth/ProtectedRoute';
import { WorkoutInfoPage } from '../pages/WorkoutInfo/WorkoutInfo';

interface AppRoutesProps {
  isAuthenticated: boolean;
  onLogin: (email: string, password: string) => void;
  onLogout: () => void;
}

export function AppRoutes({ isAuthenticated, onLogin, onLogout }: AppRoutesProps) {
  return (
    <Routes>
      {/* Login route */}
      <Route
        path="/login"
        element={
          isAuthenticated ? (
            <Navigate to="/dashboard" replace />
          ) : (
            <LoginForm onLogin={onLogin} />
          )
        }
      />

      {/* Protected layout with nested routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <DashboardLayout onLogout={onLogout} />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="competitions" element={<CompetitionsPage />} />
        <Route path="exercises" element={<ExercisesPage />} />
        <Route path="programs" element={<ProgramsPage />} />
        <Route path="program-constrained" element={<ConstrainedProgramsPage />} />
        <Route path="workouts-info" element={<WorkoutInfoPage />} />
      </Route>

      {/* Redirect unknown routes */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
